import api from './api';
import apiPublic from './apiPublic';

export const eventServices = {
  /** Public: resolve eventCode/template/photo by eventId (short guest URLs). */
  getGuestEvent: async (eventId) => {
    const id = encodeURIComponent(String(eventId).trim());
    const response = await apiPublic.get(`/media/guest-event/${id}`);
    return response.data;
  },

  createClientWithEvent: async (formData) => {
    const response = await api.post('/clients/createClientWithEvent', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getAllClientImages: async (eventCode, page = 1, limit = 10) => {
    const response = await api.get(`/clients/images/${eventCode}`, {
      params: { page, limit },
    });
    return response.data;
  },

  /** Fresh hero image for the event (call on entry when eventCode is known). */
  getMainPhotoByEventCode: async (eventCode) => {
    const response = await api.get(
      `/media/main-photo/${encodeURIComponent(String(eventCode).trim())}`
    );
    return response.data;
  },

  /** Public (no auth) version — used by the guest page to fetch the hero image. */
  getMainPhotoPublic: async (eventCode) => {
    const response = await apiPublic.get(
      `/media/main-photo/${encodeURIComponent(String(eventCode).trim())}`
    );
    return response.data;
  },

  uploadImages: async (formData, { onUploadProgress } = {}) => {
    const response = await api.post('/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
    return response.data;
  },

  uploadVideos: async (formData, { onUploadProgress } = {}) => {
    const response = await api.post('/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
    return response.data;
  },

  addComment: async (commentData) => {
    const response = await api.post('/media/upload', commentData);
    return response.data;
  },

  getTemplateById: async (templateId) => {
    const response = await api.get(`/templates/${templateId}`);
    return response.data;
  },

  getAllEvents: async (token) => {
    // Store original token from localStorage
    const originalToken = localStorage.getItem('token');
    
    // If token is provided, set it in localStorage temporarily
    if (token) {
      localStorage.setItem('token', token);
    }
    
    try {
      // Try different possible endpoints
      const endpoints = [
        '/clients/events',
        '/clients',
        '/events'
      ];
      
      let lastError = null;
      
      // Try each endpoint until one works
      for (const endpoint of endpoints) {
        try {
          const response = await api.get(endpoint);
          // Restore original token
          if (token && originalToken !== token) {
            if (originalToken) {
              localStorage.setItem('token', originalToken);
            } else {
              localStorage.removeItem('token');
            }
          }
          return response.data;
        } catch (error) {
          lastError = error;
          // Continue to next endpoint
          continue;
        }
      }
      
      // If all endpoints failed, throw the last error
      throw lastError;
    } catch (error) {
      // Restore original token on error
      if (token && originalToken !== token) {
        if (originalToken) {
          localStorage.setItem('token', originalToken);
        } else {
          localStorage.removeItem('token');
        }
      }
      throw error;
    }
  },
}; 